import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  
     constructor(public hs: HttpService, public gs: GlobalService) { }
      async login_user(value: any) {
        try {
          delete value.id;
          let response = await this.hs.post('/user/log-in', {}, value)
          return response;
        } catch (error: any) {
          throw error;
        }
      }

      async send_otp(value: any) {
        try {
          delete value.id;
          let response = await this.hs.post('/user/forgot-password', {}, value)
          return response;
        } catch (error: any) {
          throw error;
        }
      }

      async verify_otp(value: any) {
      try {
        let response = await this.hs.post('/auth/verify-otp', {},value)
        return response;
      } catch (error: any) {
        throw error;
      }
    }

    async update_password(value: any) {
      try {
        let response = await this.hs.post('/user/reset-password', {},value)
        return response;
      } catch (error: any) {
        throw error;
      }
    }

     async logout(value: any) {
      try {
        let response = await this.hs.post('/user/log-out', {},value)
        return response;
      } catch (error: any) {
        throw error;
      }
    }
    
      
}
